module.exports = __webpack_public_path__ + "img/target (1) (1).a14a37a4.svg";